export default "<h3>Audience Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"